import { render, staticRenderFns } from "./benefits-tier-delete-modal.vue?vue&type=template&id=0c1c3990&scoped=true"
import script from "./benefits-tier-delete-modal.vue?vue&type=script&lang=js"
export * from "./benefits-tier-delete-modal.vue?vue&type=script&lang=js"
import style0 from "./benefits-tier-delete-modal.vue?vue&type=style&index=0&id=0c1c3990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c3990",
  null
  
)

export default component.exports